module.exports = __webpack_public_path__ + "img/no-results.221fa1dc.svg";